import { render, staticRenderFns } from "./XiaohongshuWriter.vue?vue&type=template&id=28af1c8a&scoped=true"
import script from "./XiaohongshuWriter.vue?vue&type=script&lang=js"
export * from "./XiaohongshuWriter.vue?vue&type=script&lang=js"
import style0 from "./XiaohongshuWriter.vue?vue&type=style&index=0&id=28af1c8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28af1c8a",
  null
  
)

export default component.exports